import React, {useContext} from 'react';
import {AppContext} from "../AppContext";

class ContentColumn extends React.Component {
    content_column_element;

    constructor(props) {
        super(props);
        //this.setContentColumnElement();
    }

    setContentColumnElement() {
        this.content_column_element = (
            <div className="Content-Column">
                {this.props.content}
            </div>
        );
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        //this.setContentColumnElement();
    }

    render() {
        return (
            <div className="Content-Column">
                {this.props.content}
            </div>
        );
    }
}

const ContentColumnWithContext = (props) => {
    const context = useContext(AppContext);
    return (<ContentColumn {...props} context={context} />);
};

export default ContentColumnWithContext;
